import { useState } from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  const [copied, setCopied] = useState(false);
  const path = window.location.pathname;

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-background-50">
      {/* Decorative large 404 */}
      <span className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-foreground-50 select-none pointer-events-none z-0 leading-none">
        404
      </span>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold text-foreground-900 mt-6">
          Página não encontrada
        </h1>
        <p className="mt-2 text-base text-foreground-400 font-label">
          {path}
        </p>
        <p className="mt-4 text-lg md:text-xl text-foreground-500">
          A página que procura não existe ou foi movida.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-6 px-6 py-3 bg-foreground-950 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors"
        >
          <i className="ri-arrow-left-line"></i>
          Voltar ao Início
        </Link>
      </div>
    </div>
  );
}